export const isWorkspaceFeatureEnabled = (workspace, featureName) => {
  if (!workspace) {
    return false;
  }

  const featureInFeaturesObject = workspace?.features?.[featureName]?.enabled;
  
  if (featureInFeaturesObject !== undefined) {
    return featureInFeaturesObject;
  }

  const featureEnabledKey = `${featureName}Enabled`;
  const featureInWorkspace = workspace[featureEnabledKey];
  
  if (featureInWorkspace !== undefined) {
    return featureInWorkspace;
  }

  return false;
};
